import { useState } from 'react'
import { ButtonProps } from '../config/menu'
import { GithubPicker } from '@hello-pangea/color-picker'
import { Editor } from '@tiptap/core'

const MenuColorPickerButton = (props: Omit<ButtonProps, "type"> & { editor: Editor}) => {

    const [colorPickerVisible, setColorPickerVisible] = useState(false)

    const popover = {
        position: 'absolute' as const,
        zIndex: '2',
        left: '-3px',
        top: '30px'
    }
    const cover = {
        position: 'fixed' as const,
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
    }

    const colors = [
        '#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', 
        '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB',
        '#000000', '#333333', '#555555', '#777777', '#999999', '#BBBBBB', '#DDDDDD', '#FFFFFF'
    ]

    const handleClick = () => {
        setColorPickerVisible(!colorPickerVisible)
    };

    const handleClose = () => {
        setColorPickerVisible(false)
    };


    return (
        <span style={{ position: "relative" }}>
            <button id={props.id} type='button' onClick={handleClick} title={props.name} className='menu-item'><props.Icon /></button>
            {colorPickerVisible ? (<div style={popover}>
                <div style={cover} onClick={handleClose} />
                <GithubPicker colors={colors} onChangeComplete={(color) => { props.onClick(props.editor, color.hex) }} />
            </div>) : null}
        </span>
    )
}


export default MenuColorPickerButton;

